<div class="container">
   <div class="attachment-container">
      <span
         *ngFor="let attachment of attachments; let i = index"
         [style]="{
            'max-width':
               'calc(100% / ' +
               (attachments.length < attachmentDisplayLimit ? attachments.length : attachmentDisplayLimit) +
               ')'
         }"
      >
         <samweb-attachment-item
            *ngIf="i < attachmentDisplayLimit"
            [overlayIcon]="downloadItemIcon"
            [attachment]="attachment"
            [messageId]="messageId"
            (click)="downloadAttachment($event)"
         >
         </samweb-attachment-item>
      </span>
   </div>
   <ng-container *ngIf="attachments.length > attachmentDisplayLimit">
      <button kendoButton look="flat" #attachmentExpandButton (click)="openAttachmentDialog()">
         {{ '+' + (attachments.length - attachmentDisplayLimit) }}
      </button>

      <kendo-popup
         *ngIf="displayOtherAttachments"
         class="popup"
         [anchor]="attachmentExpandButton"
         [anchorAlign]="{ horizontal: 'right', vertical: 'bottom' }"
         [popupAlign]="{ horizontal: 'right', vertical: 'top' }"
         (samwebOutsideClick)="closeAttachmentDialog()"
      >
         <div class="popup-item" *ngFor="let attachment of attachments; let i = index">
            <samweb-attachment-item
               *ngIf="i >= attachmentDisplayLimit"
               [overlayIcon]="downloadItemIcon"
               [attachment]="attachment"
               [messageId]="messageId"
               (click)="downloadAttachment($event)"
            >
            </samweb-attachment-item>
         </div>
      </kendo-popup>
   </ng-container>
   <button
      *ngIf="attachments.length > 1"
      kendoButton
      look="flat"
      (click)="downloadAttachments()"
      kendoTooltip
      title="
         {{ 'messages_actions.download_attachments' | translate }}
      "
   >
      <fa-icon [fixedWidth]="true" class="sam-center download-icon" [icon]="downloadIcon"></fa-icon>
   </button>
</div>
